import { useCallback } from 'react';
import { getObservabilityClient } from '@locus-taxy/encore-observability/observability';
import { useAuth0 } from '../auth';
import { useUser } from './useUser';
import { O11yEventName } from '../utils/o11yUtils';

export function useLogoutWithO11y(): (options?: {
  logoutParams?: { returnTo?: string };
}) => Promise<void> {
  const { logout } = useAuth0();
  const { user } = useUser();

  return useCallback(
    async (options?: { logoutParams?: { returnTo?: string } }) => {
      const observabilityClient = getObservabilityClient();
      if (observabilityClient && user?.userId) {
        const uniqueUserIdentifier = `${user.userId}/${user.clientId}`;

        observabilityClient.trackEvent({
          name: O11yEventName.UserLoggedOut,
          // Keeping the payload similar to identifyUser payload
          attributes: {
            id: uniqueUserIdentifier,
            email: uniqueUserIdentifier,
          },
        });
      }

      return logout(options);
    },
    [logout, user]
  );
}
